import styled from '@emotion/styled';
import { useHelpContext } from './HelpContext';
import { Button, Popconfirm, Popover, PopoverProps } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { HelpStep } from './HelpContextV2';
import { HTMLAttributes } from 'react';
import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import personImage from 'views/BootGuide/assets/person.png';

export function Help({
  step: propStep,
  activityType,
  ...otherProps
}: HTMLAttributes<HTMLDivElement> & { step?: HelpStep; activityType?: Knowledge.Activity.Type }) {
  const {
    stepState: [stateStep],
    displayState: [, setDisplay],
    stepTitleMap,
    getStepTitleMap,
    stepContentMap,
  } = useHelpContext();

  const step = propStep || stateStep;
  const title = activityType ? getStepTitleMap(activityType)[step] : stepTitleMap[step];
  const content = stepContentMap[step];

  return (
    <Container {...otherProps}>
      <header>
        <h4>{title}</h4>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={() => setDisplay(false)}
        />
      </header>
      <div>{content}</div>
    </Container>
  );
}

export function InlineHelp({ step, ...otherProps }: PopoverProps & { step: HelpStep }) {
  const {
    inline,
    displayState: [display],
    stepState: [helpStep],
  } = useHelpContext();

  return (
    <Popover
      visible={inline && display && step === helpStep}
      placement="rightTop"
      content={<Help step={step} />}
      overlayClassName={styles.overlay}
      getPopupContainer={(trigger) => trigger}
      zIndex={998}
      {...otherProps}
    />
  );
}

export function HelpMinimized() {
  const { t } = useTranslate();

  const {
    displayState: [display, setDisplay],
    hiddedState: [hidded, setHidded],
  } = useHelpContext();

  if (display) {
    return <></>;
  }

  return (
    <Popconfirm
      visible={!hidded}
      arrowPointAtCenter
      placement="leftTop"
      title={t('当需要与小乐一同填写时，点击此按钮即可开始')}
      showCancel={false}
      okText={t('account.我知道了')}
      okType="link"
      onConfirm={() => setHidded({ trigger: 'ACTIVITY_HELP_HIDDED' })}
      getPopupContainer={(trigger) => trigger}
    >
      <Minimized onClick={() => setDisplay(true)}>
        <img src={personImage} alt="lady" />
        {t('和小乐一起填写')}
      </Minimized>
    </Popconfirm>
  );
}

const Container = styled.div`
  width: 240px;
  background: linear-gradient(-54deg, #9961fd 0%, #457cff 100%);
  border-radius: 8px;
  z-index: 999;
  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 16px;
    > h4 {
      margin-bottom: 0;
      font-weight: 400;
      color: #fff;
    }
    > button {
      color: #fff;
    }
  }
  > div {
    padding: 12px 16px;
    font-size: 12px;
    white-space: pre-wrap;
    background: #fff;
    border-radius: 8px;
  }
`;

const styles = {
  overlay: css`
    .ant-popover-inner {
      border-radius: 8px;
    }
    .ant-popover-inner-content {
      padding: 0;
    }
    .ant-popover-arrow-content {
      background: #457cff;
    }
  `,
};

const Minimized = styled.div`
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  border-radius: 16px;
  background: linear-gradient(-78deg, #9961fd 0%, #457cff 100%);
  cursor: pointer;
  > img {
    height: 39px;
    margin: -13px 6px 0 0;
  }
  .ant-popconfirm {
    top: 16px !important;
  }
`;
